import { CodeInlineLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useExportAsSitemap } from '@/hooks'
import { ExportItem } from '../ExportItem'

export const ExportSitemapXml: React.FC = () => {
  const onClick = useExportAsSitemap(true)

  return (
    <ExportItem
      label="Sitemap.xml"
      exportable
      icon={CodeInlineLight}
      onClick={onClick}
    />
  )
}
